import React from 'react'
import { HeaderBlock, useAtSize, Separator, WhiteText, LayoutBand, Row } from '@fs/zion-ui'
import { i18n } from '@fs/zion-locale'
import { useHistory, useLocation } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import i18next from 'i18next'
import image from './assets/landing-family.jpg'
import Search from '../search/Search'
import { getCachedSearchParams, setCachedSearchParams } from '../../services/search-service'

const mainContainerCss = css`
  padding-top: 24px;
  padding-bottom: 24px;
  background-image: linear-gradient(90deg, #a0024cbb, #279aadbb), url('${image}');
  background-size: cover;
  background-position: center 10%;
  text-align: center;
`

export default function HomePageHeader(): JSX.Element {
  const [t] = useTranslation()
  const location = useLocation()
  const atSize = useAtSize()
  const isMobile = atSize({ md: false, default: true })
  const history = useHistory()
  const initialParams = getCachedSearchParams()
  const doExternalLink =
    location.pathname.endsWith(`/${i18n.language}`) ||
    location.pathname.endsWith(`/${i18n.language}/`) ||
    window?.location?.hostname === 'localhost'

  function onSearchSubmit(params: Record<string, string>): void {
    setCachedSearchParams(params)
    if (window?.location?.href) {
      history.push(`/${doExternalLink ? i18next.language : 'en'}/search`)
    }
  }

  return (
    <WhiteText>
      <LayoutBand css={mainContainerCss} maxWidth="xs">
        <HeaderBlock size="lg" heading={t('ancestors.page.header')} subHeading={t('ancestors.page.subheader')} />

        <Separator size={isMobile ? 'sm' : 'xl'} />

        <Row alignX="center">
          <Search
            params={initialParams}
            header={t('ancestors.search-for-ancestor.header')}
            onSubmit={onSearchSubmit}
            analytics={{ link_page: 'Home: Header' }}
          />
        </Row>
      </LayoutBand>
    </WhiteText>
  )
}
